exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-truncate__content.text-truncate__content--collapse[data-v-08357a06],.text-truncate__content[data-v-08357a06]{font-size:var(--text-truncate-font-size);line-height:var(--text-truncate-line-height)}.text-truncate__content.text-truncate__content--collapse[data-v-08357a06]{display:block;display:-webkit-box;-webkit-line-clamp:var(--text-truncate-line-clamp);-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.text-truncate__action[data-v-08357a06]{display:inline-flex;margin-top:.5rem;font-size:var(--text-truncate-font-size);text-decoration:underline}", ""]);

// exports
